import { createSlice } from "@reduxjs/toolkit";
 
interface AnalyticsDataState {
  newCustomerCount: number;
  repeatCustomerCount: number;
  notPurchasedLastSixMonths: number;
  totalOutstandingCustomers: number;
  totalPayableSupplier: number;
  totalOrderValue: number;
  totalTransporterOrderValue?: number; // Optional since it's added in reset
}
 
const initialState: AnalyticsDataState = {
  newCustomerCount: 0,
  repeatCustomerCount: 0,
  notPurchasedLastSixMonths: 0,
  totalOutstandingCustomers: 0,
  totalPayableSupplier: 0,
  totalOrderValue: 0,
};
 
export const analyticsData = createSlice({
  name: "analyticsData",
  initialState,
  reducers: {
    setAnalyticsData: (_, action) => {
      return action.payload;
    },
    resetAnalyticsData: (state) => {
      return {
        ...state,
        newCustomerCount: 0,
        repeatCustomerCount: 0,
        notPurchasedLastSixMonths: 0,
        totalOutstandingCustomers: 0,
        totalPayableSupplier: 0,
        totalOrderValue: 0,
        totalTransporterOrderValue: 0,
      };
    },
  },
});
 
export const { setAnalyticsData, resetAnalyticsData } = analyticsData.actions;
 
export default analyticsData.reducer;